// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import HomeAppreciationInput from '../home-appreciation';

const HomeAppreciationInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <HomeAppreciationInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default HomeAppreciationInputWithAnalytics;
